'use es6';

import { registerQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { fetchAvailableLanguagesByLessonId } from '../api/LessonsApi';
import { quickFetchOrGet } from '../utils/ajaxUtils';
export const GET_LESSON = registerQuery({
  fieldName: 'lesson',
  args: ['lessonId', 'language'],
  fetcher({
    lessonId,
    language
  }) {
    return quickFetchOrGet(`/academy/learning-center/v1/lessons/${lessonId}/${language}`);
  }
});
export const GET_LESSON_AVAILABLE_LANGUAGES = registerQuery({
  fieldName: 'lessonAvailableLanguages',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return fetchAvailableLanguagesByLessonId(lessonId).then(data => data.map(lang => lang.toUpperCase()));
  }
});